export const SCRUB_FIELD_SHELL_CLASS =
  "group flex h-7 min-w-0 items-center gap-1 rounded bg-white/[0.04] px-1.5 transition-colors focus-within:bg-white/[0.06] focus-within:outline focus-within:outline-1 focus-within:outline-sky-500/70 has-[:disabled]:opacity-40";

export const SCRUB_FIELD_LABEL_CLASS = "shrink-0 select-none tabular-nums text-[11px] text-slate-500";

export const SCRUB_FIELD_INPUT_CLASS =
  "h-6 min-w-0 w-full appearance-none border-0 bg-transparent p-0 text-left text-[11px] tabular-nums text-slate-200 shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50";
